export default __webpack_public_path__ + "static/3-082bef724b637e9fda3d8dbbcf213151.png";